export default __webpack_public_path__ + "assets/svg/Dumbbell.ee648e2cc9d3257ef295fa3ec19d5b53.svg";